import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AwsRum } from 'aws-rum-web';

import Header from './Header';
import HomePage from './HomePage';
import CompanyPage from './CompanyPage';
import ReportForm from './ReportForm';
import PrivacyPage from './PrivacyPage';
import Footer from './Footer';

try {
  const rum_config = {
    sessionSampleRate: 1,
    identityPoolId: "eu-central-1:97929a2e-6167-47fd-b573-f43c53cb95e1",
    endpoint: "https://dataplane.rum.eu-central-1.amazonaws.com",
    telemetries: ["performance", "errors", "http"],
    allowCookies: true,
    enableXRay: false,
    signing: true // If you have a public resource policy and wish to send unsigned requests please set this to false
  };

  const APPLICATION_ID = '86d0446c-c4aa-426b-8e15-e1749c8bc160';
  const APPLICATION_VERSION = '1.0.0';
  const APPLICATION_REGION = 'eu-central-1';

  const awsRum = new AwsRum(
    APPLICATION_ID,
    APPLICATION_VERSION,
    APPLICATION_REGION,
    rum_config
  );
} catch (error) {
  // Ignore errors thrown during CloudWatch RUM web client initialization
}

// --- Main App Component ---
export default function App() {
  const [theme, setTheme] = useState('dark');
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  // One-time cleanup: remove legacy `cachedCompanies` key if present.
  useEffect(() => {
    try {
      if (localStorage.getItem('cachedCompanies')) {
        localStorage.removeItem('cachedCompanies');
        try { console.info('Removed legacy cachedCompanies'); } catch (e) {}
      }
    } catch (e) {
      // ignore cleanup errors to avoid breaking the app
      console.warn('LocalStorage cleanup failed', e);
    }
  }, []);

  useEffect(() => {
    const updateOnlineStatus = () => setIsOnline(navigator.onLine);
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);
    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);

  return (
    <Router>
      <div className="bg-gray-50 dark:bg-gray-900 min-h-screen font-sans text-gray-800 dark:text-gray-200">

        {/* ✅ Inline banner that pushes header down */}
        {!isOnline && (
          <div className="bg-amber-600 text-black text-center py-2 w-full">
            ⚠️ You’re offline. Showing cached data.
          </div>
        )}

        <Header theme={theme} setTheme={setTheme} />

        <main className="p-4 md:p-8">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/report" element={<ReportForm theme={theme} />} />
            <Route path="/company/:companyName" element={<CompanyPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
          </Routes>
        </main>

        <Footer theme={theme} />
      </div>
    </Router>
  );
}